import { useEffect, useState } from 'react'

export const useIsMobileChecker = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 768) {
				setIsMobile(true)
			} else {
				setIsMobile(false)
			}
		}
		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])
	return isMobile
}

export const isPhase2 = () => {
	return sessionStorage.getItem('phase2') === 'true'
}

export const b64toBlob = (b64Data, contentType?, sliceSize?) => {
    contentType = contentType || ''
    sliceSize = sliceSize || 512
    var byteCharacters = atob(b64Data)
    var byteArrays = []
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)
        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }
    var blob = new Blob(byteArrays, { type: contentType })
    return blob
}